import { useState, type Dispatch, type SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';

import { AuthCodeForm } from '@/components/shared/AuthCodeForm/AuthCodeForm';
import { GenericFormScreen } from '@/components/shared/GenericFormScreen/GenericFormScreen';
import { Button } from '@/components/ui/Button/Button';

interface CodeStepProps {
  goToNextStep: () => void;
  goToPreviousStep: () => void;
  username: string;
  setCode: Dispatch<SetStateAction<string>>;
  errorMessage?: string;
}

export const CodeStep = ({ goToNextStep, goToPreviousStep, username, setCode, errorMessage }: CodeStepProps) => {
  const { t } = useTranslation('auth', { keyPrefix: 'forgotPassword.steps.code' });

  const [isLoading, setIsLoading] = useState(false);

  return (
    <GenericFormScreen
      title={t('title')}
      description={t('description')}
      leftActionElement={
        <Button type='button' variant='link' onClick={goToPreviousStep}>
          {t('back.label')}
        </Button>
      }
      rightActionElement={
        <Button type='submit' form='forgot-password-code-form' isLoading={isLoading} disabled={isLoading}>
          {t('submit.label')}
        </Button>
      }
    >
      <AuthCodeForm goToNextStep={goToNextStep} username={username} setCode={setCode} errorMessage={errorMessage} setIsLoading={setIsLoading} />
    </GenericFormScreen>
  );
};
